<template>
  <div class="landing">
    <header>
      <el-row>
        <el-col :xl="{ span: 10, offset: 2 }" :lg="{ span: 11, offset: 1 }" :sm="{ span: 11, offset: 1 }" :xs="{ span: 11, offset: 1 }" class="header">
          <div class="header__content reverse-color">
            <img src="../assets/logo_cbas.svg" class="header__logo" />
          </div>
        </el-col>
        <el-col :xl="{ span: 10 }" :lg="{ span: 11 }" :sm="{ span: 11 }" :xs="{ span: 11 }">
          <language-selector class="language-selector__button-container" />
        </el-col>
      </el-row>
    </header>
    <div class="section section-fullheight reverse-color welcome-section">
      <div class="section__container">
        <el-row>
          <el-col :xl="{ span: 9, offset: 2 }" :lg="{ span: 12, offset: 1 }" :sm="{ span: 20, offset: 2 }" :xs="{ span: 22, offset: 1 }">
            <div>&nbsp;</div>
            <el-col :xl="{ span: 9 }" :lg="{ span: 10 }" :sm="{ span: 24 }" :xs="{ span: 24 }" class="welcome-section__form">
              <div class="h1" v-t="'landing.welcome.title'" />
              <div class="h4" v-t="'landing.welcome.description'" />
              <div style="margin-bottom: 30px;">
                <el-button type="primary" class="button-large" style="float: right; width: 164px; margin-left: 15px;" @click="explore">
                  <img src="../assets/ico_browser.svg" style="height: 24px; float: left; padding-right: 5px;" />
                  <span style="vertical-align: middle;">{{$t('landing.welcome.explore')}}</span>
                </el-button>
                <div class="google-play-button" style="float: right;">
                  <img src="../assets/btn_google_play.png" @click="openGooglePlay" />
                </div>
              </div>
              <newsletter-input/>
            </el-col>
          </el-col>
          <el-col :xl="{ span: 6, offset: 3 }" :lg="{ span: 10, offset: 1 }" :sm="{ span: 22, offset: 1 }" class="welcome-section__app hidden-xs-only">
            <img src="../assets/img_mobile_app.png" class="image-thumb" />
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="section aboutus-section">
      <div class="section__container">
        <el-row>
          <el-col :xl="{ span: 7, offset: 2 }" :lg="{ span: 9, offset: 2 }" :sm="{ span: 22, offset: 1 }" :xs="{ span: 22, offset: 1 }">
            <div class="h2" v-t="'landing.aboutUs.title'" />
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :xl="{ span: 7, offset: 2 }" :lg="{ span: 10, offset: 2 }" :sm="{ span: 11, offset: 1 }" :xs="{ span: 22, offset: 1 }">
            <span v-t="'landing.aboutUs.columnA'" />
          </el-col>
          <el-col :xl="{ span: 7 }" :lg="{ span: 10 }" :sm="{ span: 11 }" :xs="{ span: 22, offset: 1 }">
            <span>
              <span v-t="'landing.aboutUs.columnB'" />
            </span>
          </el-col>
          <el-col :xl="{ span: 5, offset: 1 }" :lg="{ span: 24 }" class="aboutus-section__logos">
            <img src="../assets/logo_n7mobile.png" class="image-logo" />
            <img src="../assets/logo_isea.png" class="image-logo" />
          </el-col>
        </el-row>

        <el-row class="aboutus-section__cards-row" :gutter="20">
          <el-col :xl="{ span: 4, offset: 2 }" :lg="{ span: 6, offset: 2 }" :sm="{ span: 11, offset: 1 }" :xs="{ span: 22, offset: 1 }">
            <feature-card :title="$t('landing.aboutUs.features.0.title')" :image="assets.featureImage">
              {{ $t('landing.aboutUs.features.0.content') }}
            </feature-card>
          </el-col>
          <el-col :xl="{ span: 4, offset: 0 }" :lg="{ span: 6, offset: 1 }" :sm="{ span: 11 }" :xs="{ span: 22, offset: 1 }">
            <feature-card :title="$t('landing.aboutUs.features.1.title')" :image="assets.featureImage">
              {{ $t('landing.aboutUs.features.1.content') }}
            </feature-card>
          </el-col>
          <el-col :xl="{ span: 4, offset: 0 }" :lg="{ span: 6, offset: 1 }" :sm="{ span: 11, offset: 1 }" :xs="{ span: 22, offset: 1 }">
            <feature-card :title="$t('landing.aboutUs.features.2.title')" :image="assets.featureImage">
              {{ $t('landing.aboutUs.features.2.content') }}
            </feature-card>
          </el-col>
          <el-col :xl="{ span: 4, offset: 0 }" :lg="{ span: 6, offset: 5 }" :sm="{ span: 11}" :xs="{ span: 22, offset: 1 }">
            <feature-card :title="$t('landing.aboutUs.features.3.title')" :image="assets.featureImage">
              {{ $t('landing.aboutUs.features.3.content') }}
            </feature-card>
          </el-col>
          <el-col :xl="{ span: 4, offset: 0 }" :lg="{ span: 6, offset: 1 }" :sm="{ span: 11, offset: 6 }" :xs="{ span: 22, offset: 1 }">
            <feature-card :title="$t('landing.aboutUs.features.4.title')" :image="assets.featureImage">
              {{ $t('landing.aboutUs.features.4.content') }}
            </feature-card>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="section howitworks-section">
      <div class="section__container">
        <el-row>
          <el-col :xl="{ span: 18, offset: 2 }" :lg="{ span: 18, offset: 2 }" :sm="{ span: 22, offset: 1 }" :xs="{ span: 22, offset: 1 }">
            <div class="h2" v-t="'landing.howItWorks.title'" />
          </el-col>
        </el-row>
        <el-row>
          <el-col :xl="{ span: 6, offset: 2 }" :lg="{ span: 6, offset: 2 }" :sm="{ span: 16, offset: 4 }" :xs="{ span: 22, offset: 1 }" class="howitworks-section__step">
            <step-item :title="$t('landing.howItWorks.steps.0.title')" index="1" :image="assets.howItWorks.step1">
              {{ $t('landing.howItWorks.steps.0.content') }}
            </step-item>
          </el-col>
          <el-col :span="1" class="hidden-md-and-down">
            <img class="howitworks-section__separator-image" src="../assets/ico_arrow.svg" />
          </el-col>
          <el-col :xl="{ span: 6, offset: 0 }" :lg="{ span: 6, offset: 0 }" :sm="{ span: 16, offset: 4 }" :xs="{ span: 22, offset: 1 }" class="howitworks-section__step">
            <step-item :title="$t('landing.howItWorks.steps.1.title')" index="2" :image="assets.howItWorks.step2">
              {{ $t('landing.howItWorks.steps.1.content') }}
            </step-item>
          </el-col>
          <el-col :span="1" class="hidden-md-and-down">
            <img class="howitworks-section__separator-image" src="../assets/ico_arrow.svg" />
          </el-col>
          <el-col :xl="{ span: 6, offset: 0 }" :lg="{ span: 6, offset: 0 }" :sm="{ span: 16, offset: 4 }" :xs="{ span: 22, offset: 1 }" class="howitworks-section__step">
            <step-item :title="$t('landing.howItWorks.steps.2.title')" index="3" :image="assets.howItWorks.step3">
              {{ $t('landing.howItWorks.steps.2.content') }}
            </step-item>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="section copyright-section reverse-color">
      <el-row type="flex">
        <el-col :xl="{ span: 8, offset: 2}" :lg="{ span: 11, offset: 2 }" :sm="{ span: 20, offset: 2 }" :xs="{ span: 22, offset: 1 }">
          <div class="copyright-section__content">
            <el-row>
              <el-col :sm="{ span: 8 }" :xs="{ span: 24 }" class="footer__company">
                N7 MOBILE SP. Z O.O.<br> Bukowińska 12/1301 <br> 02-703 Warszawa <br> Poland
                <br> NIP: 9522104393
              </el-col>
              <el-col :sm="{ span: 8 }" :xs="{ span: 24 }" class="footer__company">
                i-Sea SAS<br>RCS Bordeaux<br>SIRET : 804 000 602<br>APE: 7112B<br>VAT : FR12 804 000 602.
              </el-col>
              <el-col :sm="{ span: 8 }" :xs="{ span: 24 }" class="footer__company">
                Cyanobacteria bloom alert is a project founded under Neptune Blue Growth Accelelator
              </el-col>
            </el-row>
            <el-row class="hidden-xs-only">
              <el-col :span="8">
                <a href="https://n7mobile.com" target="_about">
                  <img src="../assets/logo_n7mobile_reversed.png" class="image-logo" />
                </a>
              </el-col>
              <el-col :span="8">
                <a href="http://i-sea.fr" target="_about">
                  <img src="../assets/logo_isea_reversed.png" class="image-logo" />
                </a>
              </el-col>
              <el-col :span="8">
                <img src="../assets/logo_neptune_reversed.png" class="image-logo" style="height: auto;" />
              </el-col>
            </el-row>
          </div>
        </el-col>
        <el-col :xl="{ span: 13, offset: 1 }" :lg="{ span: 10, offset: 1 }" :xs="{ span: 22, offset: 1 }" class="copyright-section__photo hidden-md-and-down">&nbsp;</el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import LanguageSelector from '@/components/landing/LanguageSelector'
import NewsletterInput from '@/components/landing/NewsletterInput'
import FeatureCard from '@/components/landing/FeatureCard'
import StepItem from '@/components/landing/StepItem'

export default {
  name: 'Landing',
  components: {
    LanguageSelector,
    NewsletterInput,
    FeatureCard,
    StepItem
  },
  data() {
    return {
      assets: null
    }
  },
  methods: {
    explore() {
      this.$router.push('explore')
      this.$ga.event('LandingPage', 'click_explore', 'button')
    },
    openGooglePlay() {
      this.$ga.event('LandingPage', 'click_googlePlay', 'button')
      window.open(process.env.GOOGLE_PLAY_LINK)
    }
  },
  created() {
    this.assets = {
      featureImage: require('../assets/ico_world.svg'),
      howItWorks: {
        step1: require('../assets/ico_satellite.svg'),
        step2: require('../assets/ico_scientist.svg'),
        step3: require('../assets/ico_notification.svg')
      }
    }
  },
  metaInfo() {
    return {
      title: this.$t('landing.welcome.title'),
      meta: [
        { name: 'description', content: this.$t('landing.welcome.description') }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../sass/var";
@import "~element-ui/packages/theme-chalk/src/display";

$--section-paddings: (
  lg: 104px,
  sm: 64px,
  xs: 32px
);

$--header-height: 54px;

.landing {
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
}

%flex-column {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

header {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  padding: 18px 0;
  background: rgba(5, 17, 19, 0.95);

  .header {
    display: flex;
    align-items: center;
    text-shadow: 0 0 4px rgba(0, 0, 0, 0.9);

    .header__content {
      display: flex;
      justify-content: center;

      & *:first-child {
        padding-right: 12px;
      }

      .header__logo {
        height: 50px;
        width: auto;
        filter: drop-shadow(0 0 4px rgba(0, 0, 0, 0.9));
      }

      .h3 {
        margin: 0;
        line-height: 24px;
      }
    }
  }
}

.language-selector__button-container {
  float: right;
}

.section {
  width: 100%;
  @extend %flex-column;

  .section__container {
    @extend %flex-column;
    @media screen and (min-width: $--lg) {
      padding: map-get($--section-paddings, lg) 0;
    }
    @media screen and (max-width: $--lg) and (min-width: $--sm) {
      padding: map-get($--section-paddings, sm) 0;
    }
    @media screen and (max-width: $--sm) {
      padding: map-get($--section-paddings, xs) 0;
    }
  }
}

.section-fullheight {
  @media screen and (min-width: $--sm) {
    min-height: 100vh;
  }
}

.reverse-color {
  color: white !important;

  .h1,
  .h2,
  .h3,
  .h4,
  .h2medium {
    color: white !important;
  }
}

.image-thumb {
  width: auto;
  height: 100%;
  display: block;
}

.image-logo {
  max-height: 100px;
  height: auto;
  width: auto;
  max-width: 100%;
}

.welcome-section {
  background-image: url("../assets/bg_header.jpg");
  background-size: cover;

  @media screen and (max-width: $--sm - 1) {
    padding-top: $--header-height;
  }

  .welcome-section__form {
    @extend %flex-column;
    @media screen and (max-width: $--lg - 1) {
      text-align: center;
    }
    @media screen and (min-width: $--lg) {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }
    @media screen and (max-width: $--lg - 1) and (min-width: $--sm) {
      padding: 72px 0;
    }
  }

  .welcome-section__app {
    @media screen and (max-width: $--lg - 1) {
      display: flex;
      justify-content: center;
    }
  }

  .google-play-button {
    height: $--large-button-height;

    img {
      height: 100%;
      width: auto !important;
      cursor: pointer;
    }
  }

  .cbas-explore-button {
    margin-left: 15px;
    width: 150px;
  }
}

.aboutus-section {
  .section__container {
    position: relative;
    z-index: 1;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      opacity: 0.1;
      z-index: -1;
      background: url("../assets/bg_terrain_map.png");
      background-size: 300px;
    }
  }

  .aboutus-section__logos {
    text-align: center;
    & > * {
      margin: 15px;
    }
  }

  .aboutus-section__cards-row {
    @media screen and (max-width: $--sm - 1) {
      padding-top: map-get($--section-paddings, xs);

      div:nth-child(n + 2) {
        margin-top: 24px;
      }
    }

    @media screen and (min-width: $--sm) and (max-width: $--lg - 1) {
      padding-top: map-get($--section-paddings, sm);

      div:nth-child(n + 3) {
        margin-top: 16px;
      }

      div:nth-child(5) {
        position: relative;
        left: 2.25%;
      }
    }

    @media screen and (min-width: $--lg) and (max-width: $--xl - 1) {
      padding-top: map-get($--section-paddings, lg);

      div:nth-child(n + 4) {
        margin-top: 32px;
        position: relative;
        // Should be updated in case of children change
        left: 2.3%;
      }
    }

    @media screen and (min-width: $--xl) {
      padding-top: map-get($--section-paddings, lg);

      div:nth-child(2n) {
        margin-top: 80px;
      }
    }
  }
}

.howitworks-section {
  background: #f5f9fa;

  @media screen and (max-width: $--lg) {
    .h2 {
      text-align: center;
    }
  }

  .howitworks-section__separator-image {
    height: 125px;
    width: 100%;
    margin-top: 32px;
    object-position: center;
  }
}

.copyright-section {
  background-color: #051a59;

  .copyright-section__content {
    @media screen and (max-width: $--sm - 1) {
      padding: map-get($--section-paddings, xs) 0;
    }

    @media screen and (min-width: $--sm) and (max-width: $--lg - 1) {
      padding: map-get($--section-paddings, sm) 0;
    }

    @media screen and (min-width: $--lg) and (max-width: $--xl - 1) {
      padding: map-get($--section-paddings, lg) 0;
    }

    @media screen and (min-width: $--xl) {
      padding: map-get($--section-paddings, lg) 0;
    }

    .footer__company {
      @media screen and (max-width: $--sm - 1) {
        border-bottom: 1px solid rgba(255, 255, 255, 0.185);
        &:last-child {
          border: none;
        }
      }
      margin-bottom: 12px;
      padding-bottom: 12px;
    }
  }

  .copyright-section__photo {
    background-image: url("../assets/bg_footer.jpg");
    background-size: cover;
    position: relative;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Landing.vue